<template>
	<v-app>
		<v-container justify-center align-center>
			<v-img width="460" :src="logo"></v-img>
			<h2 style="margin-top: 1em">彩藤 神楽 公式サイト</h2>
			<div style="border-top:1px gray solid">
				主に美少女系作品の創作に携わってきた彩藤神楽(さいとう かぐら)の個人サイトです。<br />
				略歴の紹介と本人確認のために公開しています。<br />
				現在は健康上の理由により出来ることが限られています。<br />
				<ul style="margin-top: 1em">
					<li>X: <a href="https://x.com/SaitohKagura" target="_blank">https://x.com/SaitohKagura</a></li>
					<li>pixiv: <a href="https://www.pixiv.net/users/108332560" target="_blank">https://www.pixiv.net/users/108332560</a></li>
					<li>pixivFANBOX: <a href="https://saitohkagura.fanbox.cc/" target="_blank">https://saitohkagura.fanbox.cc/</a></li>
					<li>Amazon Kindleストア:<a href="https://www.amazon.co.jp/dp/B0DBZD3TJW" target="_blank">『冒険者配信中！』</a></li>
					<li>ニコニコ静画: <a href="https://manga.nicovideo.jp/comic/69319" target="_blank">『冒険者配信中！』</a></li>
				</ul>
			</div>
		</v-container>
		<v-content>
			<WorkHistory/>
		</v-content>
		<v-container justify-center align-center>
			<div style="border-top: 1px gray solid; margin: 1em 0;">
				&copy;彩藤神楽 2024
			</div>
		</v-container>
	</v-app>
</template>

<script>
import WorkHistory from './components/WorkHistory';

export default {
	name: 'App',

	components: {
		WorkHistory,
	},

	data: () => ({
		logo: require('@/assets/logo.gif')
	}),
};
</script>
